import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import Helmet from 'react-helmet';
import FormikWizard from 'formik-wizard';
import Stepper from '../../../components/Stepper/Stepper';
import Steps from './steps';
import CustomSideBar from '../../../common/components/Sidebar/Sidebar';
import Header from '../../../common/components/Header/Header';
import { siteTitle } from '../../../../data/SiteConfig';
import SideImage from '../../../images/icons/KYCComplete.svg';
import Applicant from '../../../images/icons/applicant.svg';
import { getLapInfo } from '../../../common/utils/LapInfo';
import backBtn_icon from '../../../images/icons/backBtn_icon.svg';

const stepsText = ['KYC', 'Income', 'Property'];
const icons = {
  1: <div className="text-lg">1</div>,
  2: <div className="text-lg">2</div>,
  3: <div className="text-lg">3</div>
};
function FormWrapper({ children, wizard, steps, canGoBack }) {
  const [applicantInformation, setApplicantInformation] = useState(false);

  useEffect(() => {
    setApplicantInformation(
      getLapInfo().companyName
        ? getLapInfo().companyName
        : localStorage.hasOwnProperty('ApplicantUserKycInfo')
        ? JSON.parse(localStorage.getItem('ApplicantUserKycInfo'))?.name
            ?.firstName
        : false
    );
  }, []);

  const ApplicantClick = () => {
    navigate(`/app/leadprofile`);
  };
  const pushNextStep = () => {
    let currStepIndex = wizard.steps.indexOf(wizard.step);
    wizard.push(steps[currStepIndex + 1]);
  };
  useEffect(() => {
    let stepIndex;
    let doc = localStorage.hasOwnProperty('loadComponent')
      ? localStorage.getItem('loadComponent')
      : false;
    if (doc) {
      if (doc == 'itr') {
        stepIndex = 'itr';
      } else if (
        doc == 'company_registration_certificate' ||
        doc == 'moa' ||
        doc == 'aoa' ||
        doc == 'board_resolution' ||
        doc == 'share_holding_pattern' ||
        doc == 'partnership_deed'
      ) {
        stepIndex = 'docsLists';
      } else if (doc == 'salaried_bank_statement') {
        stepIndex = 'AddSalary';
      } else if (doc == 'other_income_itr') {
        stepIndex = 'otherIncomes';
      } else if (doc == 'obligations_loan_sanctioned') {
        stepIndex = 'AddLoan';
      }
      if (
        doc == 'business_address_proof_shop_establishment' ||
        doc == 'business_address_proof_rental_agreement' ||
        doc == 'business_address_proof_electricity_bill' ||
        doc == 'business_address_proof_lpg' ||
        doc == 'business_address_proof_png'
      ) {
        stepIndex = 'addProof';
      }

      if (stepIndex) {
        wizard.push(steps.find((_, i) => _ === stepIndex));
      }

      localStorage.hasOwnProperty('loadComponent')
        ? localStorage.removeItem('loadComponent')
        : false;
    }
  }, []);

  const handleGoBack = () => {
    if (!canGoBack) return;
    let currStepIndex = wizard.steps.indexOf(wizard.step);
    wizard.push(steps[currStepIndex - 1]);
  };

  return (
    <React.Fragment>
      <Helmet title={`Income  | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0">
          <CustomSideBar />
          <div className="flex-1  w-full widhtMd max-screen">
            <Header />
            <div className="flex-1 pb-8 flex-row w-full relative">
              <div className="w-full flex">
                <div className="md:ml-5  w-full md:w-8/12 px-2 md:bg-white min-h-screen md:py-2">
                  <div
                    className="w-12 px-1 py-1 text-center cursor-pointer"
                    onClick={ApplicantClick}
                  >
                    <img
                      className="mr-auto w-full  rounded-md"
                      src={Applicant}
                    />
                    <p
                      className="font-roboto font-normal text-black-500 mx-auto"
                      style={{ fontSize: '10px' }}
                    >
                      {applicantInformation
                        ? `${applicantInformation}`
                        : 'Applicant'}
                    </p>
                  </div>
                  <div className="overflow-x-auto">
                    <Stepper
                      activeStep={1}
                      stepsText={stepsText}
                      stepIcons={icons}
                    />
                  </div>
                  <div></div>
                  <div className="w-full flex">
                    <div
                      className={`w-10  mx-2 my-3 ${
                        !canGoBack
                          ? 'opacity-25 cursor-not-allowed'
                          : 'cursor-pointer'
                      }`}
                    >
                      <img onClick={handleGoBack} src={backBtn_icon} alt="" />
                    </div>
                    <p
                      className="font-roboto ml-auto mr-3 float-right mt-2 pb-2 text-red-100 font-medium text-lg bottom-0 mx-auto md:mr-5 cursor-pointer float-right"
                      onClick={pushNextStep}
                    >
                      Skip
                    </p>
                  </div>
                  {children}
                </div>

                <div className="w-1/4 hidden md:block">
                  <img
                    className="inset-x-0 bottom-0"
                    src={SideImage}
                    style={{ position: 'fixed', bottom: 0, left: '80%' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const IncomeDetails = () => {
  const handleSubmit = React.useCallback(values => {
    return {
      message: 'Thanks for submitting!'
    };
  }, []);

  return (
    <FormikWizard steps={Steps} onSubmit={handleSubmit} render={FormWrapper} />
  );
};
export default IncomeDetails;
